import type { ReactNode } from 'react'
import logo from '@/assets/logo.svg'

interface AuthLayoutProps {
  children: ReactNode
  title?: string
  subtitle?: string
}

export function AuthLayout({
  children,
  subtitle = 'AI-powered Media analysis',
}: AuthLayoutProps) {
  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        {/* Logo Section */}
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <a href="https://www.myralabs.ai" target="_blank">
              <img src={logo} alt="Myra Labs" className="w-auto h-14" />
            </a>
          </div>
          {/* {title && ( */}
          {/* <h1 className="text-2xl font-bold text-slate-900 dark:text-slate-100 mb-2">
            {title}
          </h1> */}
          {/* // )} */}
          {/* {subtitle && ( */}
          <p className="text-slate-600 dark:text-slate-400 text-sm">
            {subtitle}
          </p>
          {/* )} */}
        </div>

        {/* Auth Form Container */}
        <div
          className="bg-white dark:bg-slate-800 rounded-2xl shadow-xl border
         border-slate-200 dark:border-slate-700 overflow-hidden p-4"
        >
          {children}
        </div>

        {/* Footer */}
        <div className="text-center mt-6">
          <p className="text-xs text-slate-500 dark:text-slate-400">
            © 2025 Myra. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  )
}
